const stackList = [
  {
    //0
    stackImg: '/images/stack/aws.png',
  },
  {
    //1
    stackImg: '/images/stack/flutter.png',
  },
  {
    //2
    stackImg: '/images/stack/ios.png',
  },
  {
    //3
    stackImg: '/images/stack/java.png',
  },
  {
    //4
    stackImg: '/images/stack/nodejs.png',
  },
  {
    //5
    stackImg: '/images/stack/react.png',
  },
  {
    //6
    stackImg: '/images/stack/spring.png',
  },
  {
    //7
    stackImg: '/images/stack/springboot.png',
  },
  {
    //8
    stackImg: '/images/stack/unity.png',
  },
  {
    //9
    stackImg: '/images/stack/aws.png',
  },
  {
    //10
    stackImg: '/images/stack/flutter.png',
  },
  {
    //11
    stackImg: '/images/stack/ios.png',
  },
  {
    //12
    stackImg: '/images/stack/java.png',
  },
  {
    //13
    stackImg: '/images/stack/nodejs.png',
  },
  {
    //14
    stackImg: '/images/stack/react.png',
  },
  {
    //15
    stackImg: '/images/stack/spring.png',
  },
  {
    //16
    stackImg: '/images/stack/springboot.png',
  },
  {
    //17
    stackImg: '/images/stack/unity.png',
  },
];

export default stackList;
